import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { ProgressBar } from 'common/components/ProgressBar';
import { VsChange } from 'common/components/VsChange';
import { TrendLine } from 'common/components/TrendLine';
import { ChangeArrow } from 'entities/MonitorSales/components/ChangeArrow';
import { IImproveQscSummaryMetric } from 'entities/ImproveQsc/ImproveQsc.models';

interface IComponentProps {
  label: string;
  metric?: IImproveQscSummaryMetric;
}

export const ImproveQscSummaryRow: FC<IComponentProps> = ({ label, metric }) => {
  const { target = 0, percent = 0, vsLastPeriod = 0, vsLastYear = 0, trend = [] } = metric ?? {};
  const trendUp = trend.length >= 2 && trend[trend.length - 1] >= trend[trend.length - 2];

  return (
    <Row className="mb-5" align="middle" gutter={24} wrap={false}>
      <Col sm={8} xxl={10}>
        <ProgressBar label={label} target={label === 'QSC' ? `${target} %` : undefined} percent={percent} />
      </Col>

      <Col span={3}>
        <VsChange value={vsLastPeriod} />
      </Col>
      <Col span={3}>
        <VsChange value={vsLastYear} />
      </Col>

      <Col sm={10} xxl={8}>
        <div className="iqsc-summary__sparkline">
          <TrendLine data={trend} label={label} formatValue={(value) => `${value}%`} />
          <ChangeArrow up={trendUp} />
        </div>
      </Col>
    </Row>
  );
};
